// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"a8d06446","688":"c21d242c","749":"ea32bff3","838":"c93e4082"}[chunkId] + ".chunk.js";
};